import { motion, useReducedMotion } from "motion/react";
import type { Studio } from "@/lib/api/schemas";
import { mediaUrl } from "@/lib/env";

type Media = Studio["media"][number];

/**
 * "Works" mosaic: each photo sits in a soft frame and rises into place as it
 * scrolls into view (once), with a short stagger. Reduced motion: shown at once.
 */
export function WorksGallery({ items }: { items: Media[] }) {
  const reduce = useReducedMotion();
  return (
    <ul className="gallery-mosaic list-none">
      {items.map((g, i) => (
        <motion.li
          key={g.id}
          className="gallery-frame"
          initial={reduce ? false : { opacity: 0, y: 28, scale: 0.94 }}
          whileInView={{ opacity: 1, y: 0, scale: 1 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ type: "spring", stiffness: 260, damping: 24, delay: (i % 3) * 0.08 }}
        >
          <img src={mediaUrl(g.path)} alt={g.alt} loading="lazy" />
        </motion.li>
      ))}
    </ul>
  );
}
